import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.informativeUserRegistration.pageTitle',
    defaultMessage: 'Informativa',
    description: 'Title of the informative user registration page',
  },
  pageSubtitle: {
    id: 'features.informativeUserRegistration.pageSubtitle',
    defaultMessage:
      // eslint-disable-next-line quotes
      "Leggi l'informativa privacy per completare la registrazione",
    description: 'Subtitle of the informative user registration page',
  },
  pageSubtitleMobile: {
    id: 'features.informativeUserRegistration.pageSubtitle',
    // eslint-disable-next-line quotes
    defaultMessage: "Leggi l'informativa per completare la registrazione",
    description: 'Subtitle of the informative user registration page',
  },
  buttonInformativeUserRegistration: {
    id: 'features.informativeUserRegistration.buttonCredentialRecovery',
    defaultMessage: 'Procedi',
    description: 'Label of the informative user registration button',
  },
  disclaimerInformativeUserRegistration: {
    id: 'features.informativeUserRegistration.disclaimerInformativeUserRegistration',
    defaultMessage:
      'e presto il mio consenso specifico ed informato al trattamento dei miei dati personali per l’invio di materiale pubblicitario o di vendita diretta, il compimento di ricerche di mercato o di comunicazione commerciale con modalità di contatto automizzate (posta elettronica, sms, mms) e tradizionali (posta cartacea, telefono con operatore), consapevole che il conferimento dei dati personali per tali finalità ha natura facoltativa.',
    description: 'Disclaimer for informative user registration page',
  },
  checkboxInformativeUserRegistration: {
    id: 'features.informativeUserRegistration.checkboxInformativeUserRegistration',
    defaultMessage: 'Dichiaro di aver preso visione dell’informativa privacy',
    description: 'Checkbox for informative user registration page',
  },
  labelAgreeRadioButton: {
    id: 'features.informativeUserRegistration.labelAgreeRadioButton',
    defaultMessage: 'Acconsento',
    description: 'Label of agree radio button',
  },
  labelDisagreeRadioButton: {
    id: 'features.informativeUserRegistration.labelDisagreeRadioButton',
    defaultMessage: 'Non acconsento',
    description: 'Label of disagree radio button',
  },
});
